/* eslint-disable max-len */
import _ from 'lodash';
import moment from 'moment';
import { COMMUNICATION_EMAIL_STATUSES, COMMUNICATION_STATUSES, COMPANY_NOTIFICATIONS_ATLAS_STATES, COMPANY_NOTIFICATIONS_BATTERY_LEVELS, COMPANY_NOTIFICATIONS_BATTERY_STATES, COMPANY_NOTIFICATIONS_CREDENTIALS_STATES, COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS, COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_STATES, COMPANY_NOTIFICATIONS_GATEWAY_STATES, COMPANY_NOTIFICATIONS_REPEAT_STATES, EAGLE_EYE_CUSTOM_FIELD_DTO, LOCKS_OPEN_MODE, MATCH_TAG_MODE, MOBILE_UDID_STATES, OFFICE_MODE_PROGRAM_TYPES, RESERVATION_STATUSES, RESOURCE_CAPACITY_SLOTS, RESOURCE_CAPACITY_TYPE } from './consts';
import { elaborateCustomFieldsEntityAttributes, elaborateMksRequestDataOutPayload, elaborateSmartLockTroubleShootingId, formatDomainHostNameToDomainName, formatDomainHostNameToFriendlyName, formatOutputCustomFieldValue, getDisplayCredits, getMonthlyBurnRate, isValidEmail, calculateWearableBatteryLevel } from './utils';

export function formatTimePickerValueToSecondsFromStartOfDay(timeValue) {
  if (!timeValue) return undefined;
  const time = moment(timeValue);
  return (time.hours() * 3600) + (time.minutes() * 60) + time.seconds();
}

export function parseSecondsFromStartOfDayToTimePickerValue(seconds) {
  if (seconds === undefined || seconds === null) return undefined;
  return moment().startOf('day').add(seconds, 'seconds').valueOf();
}

export function formatSecondsFromStartOfDayToTimeDisplay(seconds) {
  if (seconds === undefined || seconds === null || seconds === '') {
    return undefined;
  }
  const parsedSeconds = _.isString(seconds) ? parseInt(seconds, 10) : seconds;
  const timeValue = parseSecondsFromStartOfDayToTimePickerValue(parsedSeconds);
  if (!timeValue) {
    return undefined;
  }
  return moment(timeValue).format('HH:mm');
}

export const GUEST = 'GUEST';
export const DOMAIN = 'DOMAIN';
export const GUEST_TAG = 'GUEST_TAG';
export const LOCK_TAG = 'LOCK_TAG';
export const LOCK = 'LOCK';
export const CREDENTIAL = 'CREDENTIAL';
export const SETTING = 'SETTING';
export const APPLICATION_SETTING = 'APPLICATION_SETTING';
export const NOTIFICATION_SETTING = 'NOTIFICATION_SETTING';
export const LOG = 'LOG';
export const TAG_DATES = 'TAG_DATES';
export const RESERVATION_DATES = 'RESERVATION_DATES';
export const INVITATION_DATES = 'INVITATION_DATES';
export const RESERVATION = 'RESERVATION';
export const RESOURCE = 'RESOURCE';
export const RESOURCE_FORM_INIT = 'RESOURCE_FORM_INIT';
export const RESOURCE_FORM_EDIT_INIT = 'RESOURCE_FORM_EDIT_INIT';
export const EVENT = 'EVENT';
export const INIT_EVENT_FORM = 'INIT_EVENT_FORM';
export const CREDENTIAL_GUEST = 'CREDENTIAL_GUEST';
export const PLATFORM_USER = 'PLATFORM_USER';
export const OFFICE_MODE_PROGRAM = 'OFFICE_MODE_PROGRAM';
export const INVITATION = 'INVITATION'
export const REGISTRY_ITEM = 'REGISTRY_ITEM';
export const COMMUNICATION = 'COMMUNICATION';
export const ACCESS_PROFILE = 'ACCESS_PROFILE';
export const WALLET_SUBSCRIPTION = 'WALLET_SUBSCRIPTION';
export const TIME_PROFILE = 'TIME_PROFILE';
export const TIME_RANGE = 'TIME_RANGE';
export const TIME_RANGE_OFFICEMODE = 'TIME_RANGE_OFFICEMODE';
export const CARD_WITH_PROFILE = 'CARD_WITH_PROFILE';
export const TICKET = 'TICKET';
export const TICKET_CATEGORY = 'TICKET_CATEGORY';
export const LOCK_GROUP = 'LOCK_GROUP';
export const AREA = 'AREA';
export const AREA_OCCUPANCY = 'AREA_OCCUPANCY';
export const AREA_OCCUPANCY_HOUR = 'AREA_OCCUPANCY_HOUR';
export const PRIVATE_UNIT = 'PRIVATE_UNIT';
export const PRIVATE_UNIT_TEMPLATE = 'PRIVATE_UNIT_TEMPLATE';
export const AREA_RULE = 'AREA_RULE';
export const LOCKER = 'LOCKER';
export const LOCKER_RESERVATION = 'LOCKER_RESERVATION';
export const LOCK_V364_CONFIGURATIONS = 'LOCK_V364_CONFIGURATIONS';
export const INTERCOM = 'INTERCOM';
export const INTERCOM_EXTENSION = 'INTERCOM_EXTENSION';
export const INTERCOM_EXTENSION_GROUP = 'INTERCOM_EXTENSION_GROUP';
export const INTERCOM_HYPER_TILE = 'INTERCOM_HYPER_TILE';
export const COMMUNICATION_USER = 'COMMUNICATION_USER';
export const CUSTOM_TABLE_ROW_DATA = 'CUSTOM_TABLE_ROW_DATA';
export const INVITATION_FORM_INIT = 'INVITATION_FORM_INIT';
export const MKS_REQUEST = 'MKS_REQUEST';
export const CREDENTIAL_AS_TEMPLATE = 'CREDENTIAL_AS_TEMPLATE';
export const WEARABLES = 'WEARABLES';
export const WEARABLE_SETTINGS = 'WEARABLE_SETTINGS';

export function formatInputData(entity, data) {
  switch (entity) {
    case WALLET_SUBSCRIPTION: {
      return {
        ...data,
        burnRateDaily: getDisplayCredits(data.burnRate),
        burnRate: getMonthlyBurnRate(data.burnRate),
        fixedPrice: getDisplayCredits(data.fixedPrice),
      };
    }
    case TIME_RANGE: {
      const timeIntervalFrom = data && data.timeInterval && data.timeInterval.from ? moment().startOf('day').add(data.timeInterval.from, 'seconds').valueOf() : moment().startOf('day').add(0, 'seconds').valueOf();
      const timeIntervalTo = data && data.timeInterval && data.timeInterval.to ? moment().startOf('day').add(data.timeInterval.to, 'seconds').valueOf() : moment().startOf('day').add(0, 'seconds').valueOf();
      return {
        daysOfTheWeek: data && data.daysOfTheWeek ? data.daysOfTheWeek : null,
        timeIntervalFrom,
        timeIntervalTo,
      };
    }
    case TIME_RANGE_OFFICEMODE: {
      const timeIntervalFrom = data && data.timeInterval && data.timeInterval.from ? moment().startOf('day').add(data.timeInterval.from, 'seconds').valueOf() : moment().startOf('day').add(0, 'seconds').valueOf();
      const timeIntervalTo = data && data.timeInterval && data.timeInterval.to ? moment().startOf('day').add(data.timeInterval.to, 'seconds').valueOf() : moment().startOf('day').add(0, 'seconds').valueOf();
      return {
        daysOfTheWeek: data && data.daysOfTheWeek ? data.daysOfTheWeek : null,
        timeIntervalFrom,
        timeIntervalTo,
        holidays: data.holidays
      };
    }
    case OFFICE_MODE_PROGRAM: {
      const index = data.index;
      const timeIntervalFrom = data && data.timeInterval && data.timeInterval.from ? moment().startOf('day').add(data.timeInterval.from, 'seconds').valueOf() : moment().startOf('day').add(0, 'seconds').valueOf();
      const timeIntervalTo = data && data.timeInterval && data.timeInterval.to ? moment().startOf('day').add(data.timeInterval.to, 'seconds').valueOf() : moment().startOf('day').add(0, 'seconds').valueOf();
      const programType = data.automatic ? OFFICE_MODE_PROGRAM_TYPES.AUTOMATIC : OFFICE_MODE_PROGRAM_TYPES.SEMIAUTOMATIC;
      return {
        daysOfTheWeek: data.daysOfTheWeek,
        enableOnFirstAccess: data.enableOnFirstAccess,
        programStartTime: timeIntervalFrom,
        programEndTime: timeIntervalTo,
        programType,
      };
    }
    case INVITATION: {
      const invitationCredentialTimeIntervalFrom = moment().startOf('day').add(data.timeInterval.from, 'seconds').valueOf();
      const invitationCredentialTimeIntervalTo = moment().startOf('day').add(data.timeInterval.to, 'seconds').valueOf();
      const invitationValidityDateFrom = moment(data.dateInterval.from).valueOf();
      const invitationValidityDateTo = moment(data.dateInterval.to).valueOf();
      const isExpired = moment(invitationValidityDateTo).isBefore(moment());
      const isNotYetActive = moment(invitationValidityDateFrom).isAfter(moment());
      let status = RESERVATION_STATUSES.ACTIVE;
      if (isExpired) {
        status = RESERVATION_STATUSES.EXPIRED;
      } else if (isNotYetActive) {
        status = RESERVATION_STATUSES.NOT_YET_ACTIVE;
      }
      return {
        ...data,
        invitationCredentialTimeIntervalFrom,
        invitationCredentialTimeIntervalTo,
        invitationStatus: status,
      };
    }
    case INVITATION_FORM_INIT: {
      const timeIntervalFrom = moment().startOf('day').add(data.timeInterval.from, 'seconds').valueOf();
      const timeIntervalTo = moment().startOf('day').add(data.timeInterval.to, 'seconds').valueOf();
      const validityDateFrom = moment(data.dateInterval.from).valueOf();
      const validityDateTo = moment(data.dateInterval.to).valueOf();
      const validityTimeFrom = moment().hour(moment(data.dateInterval.from).hour()).minutes(moment(data.dateInterval.from).minutes()).valueOf();
      const validityTimeTo = moment().hour(moment(data.dateInterval.to).hour()).minutes(moment(data.dateInterval.to).minutes()).valueOf();
      const lockTagsIds = _.map(data.lockTags, lockTag => lockTag.id);
      return {
        ...data,
        timeIntervalFrom,
        timeIntervalTo,
        validityDateFrom,
        validityDateTo,
        validityTimeFrom,
        validityTimeTo,
        lockTags: data.lockTags,
        lockTagsIds,
        lockTagMatchingMode: MATCH_TAG_MODE.AT_LEAST_ONE_TAG,
        selectedLocks: { data: data.smartLocks, pagination: { page: 0, totalElements: _.size(data.smartLocks) } },
      };
    }
    case COMMUNICATION: {
      const momentDateFrom = moment(data.fromDate);
      const momentDateTo = moment(data.toDate);
      const isExpired = momentDateTo.isBefore(moment());
      const isNotYetActive = momentDateFrom.isAfter(moment());
      let status = COMMUNICATION_STATUSES.VISIBLE;
      if (isExpired) {
        status = COMMUNICATION_STATUSES.NOT_VISIBLE;
      } else if (isNotYetActive) {
        status = COMMUNICATION_STATUSES.NOT_YET_VISIBLE;
      }
      const startDate = data.fromDate
      const startTime = data.fromDate
      const endDate = data.toDate
      const showInApp = data.showInApp || false;
      const emailStatus = data.emailStatus || null;
      const htmlContent = data.htmlContent || data.description;
      const guestTags = data.guestTags || []
      const guestTagMatchingMode = data.guestTagMatchingMode || MATCH_TAG_MODE.AT_LEAST_ONE_TAG
      return {
        ...data,

        showInApp,

        status,
        emailStatus,

        htmlContent,
        
        startDate,
        startTime,
        endDate,

        guestTags,
        guestTagMatchingMode,
      };
    }
    case LOCK_GROUP: {
      const { groupName, smartLocks, groupMasterLockId } = data;
      return {
        groupName: _.startCase(groupName),
        enabled: false,
        smartLocks,
        id: groupName,
        groupMasterLockId,
        serialNumber: groupName,
        model: _.first(smartLocks) && _.first(smartLocks).model ? _.first(smartLocks).model: 'LIBRA',
        configuration: LOCKS_OPEN_MODE.GROUP_OPEN,
      }
    };
    case ACCESS_PROFILE: {
      const timeIntervalFrom = moment().startOf('day').add(data.timeInterval.from, 'seconds').valueOf();
      const timeIntervalTo = moment().startOf('day').add(data.timeInterval.to, 'seconds').valueOf();
      const credentialDateFrom = data.dateInterval.from;
      const credentialDateTo = data.dateInterval.to;
      const dateIntervalTimeFrom = data.dateInterval.from;
      const dateIntervalTimeTo = data.dateInterval.to;
      const isExpired = moment(credentialDateTo).isBefore(moment());
      const isNotYetActive = moment(credentialDateFrom).isAfter(moment());
      const additionalTimeRange = data.additionalTimeRange && data.additionalTimeRange.timeInterval ? {
        ...data.additionalTimeRange,
        timeIntervalFrom: moment().startOf('day').add(data.additionalTimeRange.timeInterval.from, 'seconds').valueOf(),
        timeIntervalTo: moment().startOf('day').add(data.additionalTimeRange.timeInterval.to, 'seconds').valueOf(),
      } : null;
      let status = RESERVATION_STATUSES.ACTIVE;
      if (isExpired) {
        status = RESERVATION_STATUSES.EXPIRED;
      } else if (isNotYetActive) {
        status = RESERVATION_STATUSES.NOT_YET_ACTIVE;
      }
      return {
        ...data,
        timeIntervalFrom,
        timeIntervalTo,
        dateIntervalTimeFrom,
        dateIntervalTimeTo,
        credentialTimeframe: {
          startDate: data.dateInterval.from,
          endDate: data.dateInterval.to,
        },
        daysOfTheWeek: data.daysOfTheWeek,
        credentialDateFrom,
        credentialDateTo,
        status,
        additionalTimeRange: additionalTimeRange,
      };
    }
    case RESERVATION: {
      const momentDateFrom = moment(data.fromDate);
      const momentDateTo = moment(data.toDate);

      const isExpired = momentDateTo.isBefore(moment());
      const isNotYetActive = momentDateFrom.isAfter(moment());
      let status = RESERVATION_STATUSES.ACTIVE;
      if (isExpired) {
        status = RESERVATION_STATUSES.EXPIRED;
      } else if (isNotYetActive) {
        status = RESERVATION_STATUSES.NOT_YET_ACTIVE;
      }
      return {
        ...data,
        timeFrom: data.fromDate,
        timeTo: data.toDate,
        resource: data.resource,
        days: momentDateTo.diff(momentDateFrom, 'days'),
        status,
        invitedEmails: data.invitedEmails || [],
      };
    }
    case DOMAIN: {
      const { hostName } = data;
      return {
        name: _.startCase(formatDomainHostNameToFriendlyName(hostName)),
        domainName: formatDomainHostNameToDomainName(hostName),
        ...data,
      };
    }
    case GUEST: {
      const userTag = _.find(data.tags, tag => tag.type === 'user');
      const tags = _.filter(data.tags, tag => tag.type !== 'user');
      const isGuestManager = _.size(data.roles) > 1;
      const customFields = elaborateCustomFieldsEntityAttributes(data.customFields, data.customAttributes);
      return {
        ...data,
        userTag,
        isGuestManager,
        customFields,
        accessProfileId: data.accessProfileId,
        roleIds: data.roleIds,
        tags: _.map(tags, tag => ({
          ...tag,
          dateFrom: tag.from,
          dateTo: tag.to,
          timeFrom: tag.from,
          timeTo: tag.to,
        }),
        ),
        email: data.withoutEmail ? null: data.email,
      };
    }
    case LOCK: {
      const filteredAttributes = _.omitBy(data.customAttributes, _.isEmpty);
      const customFields = elaborateCustomFieldsEntityAttributes(data.customFields, filteredAttributes);
      const troubleShootingArticleId = elaborateSmartLockTroubleShootingId(data);
      const lockAccessories = _.filter(data.accessories, accessory => accessory.entityId === data.id);
      const lockHasCamera = _.find(_.keys(customFields), customFieldKey => customFieldKey === EAGLE_EYE_CUSTOM_FIELD_DTO.name && customFields[customFieldKey]);
      const lockTag = {
        color: '#ba68c8',
        name: data && data.name ? data.name : '',
        type: 'lock',
      };
      return {
        ...data,
        lockTag,
        accessories: lockAccessories,
        customFields,
        lockHasCamera,
        troubleShootingArticleId,
        cameraId: customFields[EAGLE_EYE_CUSTOM_FIELD_DTO.name],
        v364Configurations: data.v364Configurations,
        tags: (data.tags || []).filter(e=>e.type!=='private_unit') || [],
      };
    }
    case CREDENTIAL: {
      const timeIntervalFrom = moment().startOf('day').add(data.timeInterval.from, 'seconds').valueOf();
      const timeIntervalTo = moment().startOf('day').add(data.timeInterval.to, 'seconds').valueOf();
      const credentialDateFrom = moment(data.dateInterval.from).valueOf();
      const credentialDateTo = moment(data.dateInterval.to).valueOf();
      const dateIntervalTimeFrom = moment(data.dateInterval.from).valueOf();
      const dateIntervalTimeTo = moment(data.dateInterval.to).valueOf();
      const isExpired = moment(credentialDateTo).isBefore(moment());
      const isNotYetActive = moment(credentialDateFrom).isAfter(moment());
      const additionalTimeRange = data.additionalTimeRange && data.additionalTimeRange.timeInterval ? {
        ...data.additionalTimeRange,
        timeIntervalFrom: moment().startOf('day').add(data.additionalTimeRange.timeInterval.from, 'seconds').valueOf(),
        timeIntervalTo: moment().startOf('day').add(data.additionalTimeRange.timeInterval.to, 'seconds').valueOf(),
      } : null;
      let status = RESERVATION_STATUSES.ACTIVE;
      if (isExpired) {
        status = RESERVATION_STATUSES.EXPIRED;
      } else if (isNotYetActive) {
        status = RESERVATION_STATUSES.NOT_YET_ACTIVE;
      }
      return {
        ...data,
        timeIntervalFrom,
        timeIntervalTo,
        dateIntervalTimeFrom,
        dateIntervalTimeTo,
        accessProfileId: data.accessProfileId,
        credentialTimeframe: {
          startDate: data.dateInterval.from,
          endDate: data.dateInterval.to,
        },
        daysOfTheWeek: data.daysOfTheWeek,
        credentialDateFrom,
        credentialDateTo,
        status,
        additionalTimeRange: additionalTimeRange,
      };
    }
    case CREDENTIAL_GUEST: {
      const credentialDateFrom = moment(data.fromDate).valueOf();
      const credentialDateTo = moment(data.toDate).valueOf();
      const isExpired = moment(credentialDateTo).isBefore(moment());
      const isNotYetActive = moment(credentialDateFrom).isAfter(moment());
      let status = RESERVATION_STATUSES.ACTIVE;
      if (isExpired) {
        status = RESERVATION_STATUSES.EXPIRED;
      } else if (isNotYetActive) {
        status = RESERVATION_STATUSES.NOT_YET_ACTIVE;
      }
      return {
        ...data,
        credentialDateFrom,
        credentialDateTo,
        status,
      };
    }
    case LOG: {
      let payload;
      try {
        payload = data.payload ? JSON.parse(data.payload) : {};
      } catch (ex) {
        payload = data.payload;
      }
      return {
        ...data,
        payload,
      };
    }
    case WEARABLES: {
      return {
        ...data,
        secondsOutsideAllowedAreasForAlarm: data.secondsOutsideAllowedAreasForAlarm ? data.secondsOutsideAllowedAreasForAlarm / 60 : 0,
        secondsInsideNotAllowedAreasForAlarm: data.secondsInsideNotAllowedAreasForAlarm ? data.secondsInsideNotAllowedAreasForAlarm / 60 : 1,
        batteryLevel: calculateWearableBatteryLevel(data.battery),
      };
    }
    case RESOURCE: {
      const dataFormatted = data;
      const timeIntervalFrom = moment().startOf('day').add(data.timeInterval.from, 'seconds').valueOf();
      const timeIntervalTo = moment().startOf('day').add(data.timeInterval.to, 'seconds').valueOf();
      dataFormatted.resourceSmartLockTags = _.map(data.resourceSmartLockTags, tag => ({ id: tag }));
      dataFormatted.resourceUserTags = _.map(data.resourceUserTags, tag => ({ id: tag }));
      return {
        ...dataFormatted,
        credentialTimeframe: {
          startDate: dataFormatted.dateInterval.from,
          endDate: dataFormatted.dateInterval.to,
        },
        timeIntervalFrom,
        timeIntervalTo,
      };
    }

    case INIT_EVENT_FORM: {
      return {
        dateFrom: moment(data.fromDate),
        dateTo: moment(data.toDate),
        timeFrom: moment(data.fromDate).valueOf(),
        timeTo: moment(data.toDate).valueOf(),
        location: data.address || '',
        ...data,
      };
    }
    
    case TICKET: {
      return {
        ...data,
      };
    }
    
    case TICKET_CATEGORY: {
      return {
        ...data,
      };
    }
    
    case AREA: {
      const dataFormatted = data;
      dataFormatted.requiredSecondsForWearableInArea = data.requiredSecondsForWearableInArea ? data.requiredSecondsForWearableInArea / 60 : 1;
      return {
        ...dataFormatted,
      };
    }
    
    case AREA_OCCUPANCY: {
      return {
        ...data,
      };
    }
    
    case AREA_OCCUPANCY_HOUR: {
      return {
        ...data,
      };
    }
    
    case PRIVATE_UNIT: {
      return {
        ...data,
        lockTags: (data.lockTags || []).filter(e=>e.type!=='private_unit') || [],
        userTags: (data.userTags || []).filter(e=>e.type!=='private_unit') || [],
      };
    }
    
    case PRIVATE_UNIT_TEMPLATE: {
      return {
        ...data,
      };
    }
    case AREA_RULE: {
      return {
        ...data,
      };
    }
    
    case LOCKER: {
      return {
        ...data,
      };
    }
    
    case LOCKER_RESERVATION: {
      return {
        ...data,
      };
    }
    
    case INTERCOM: {
      return {
        ...data,
      };
    }
    
    case INTERCOM_EXTENSION: {
      const users = _.map(data.users, user => ({
        ...user,
        ...user.user,
      }));
      return {
        ...data,
        users,
      };
    }
    
    case INTERCOM_EXTENSION_GROUP: {
      return {
        ...data,
      };
    }
    
    case INTERCOM_HYPER_TILE: {
      return {
        ...data,
      };
    }
    
    case COMMUNICATION_USER: {
      return {
        ...data,
      };
    }
    
    default: return {};
  }
}

export function formatOutputData(entity, data) {
  switch (entity) {
    case CREDENTIAL_AS_TEMPLATE: {
      return {
        timeIntervalFrom: moment().startOf('day').add(data.timeInterval.from, 'seconds').valueOf(),
        timeIntervalTo: moment().startOf('day').add(data.timeInterval.to, 'seconds').valueOf(),
        dateIntervalTimeFrom: moment(data.dateInterval.from).valueOf(),
        dateIntervalTimeTo: moment(data.dateInterval.to).valueOf(),
        credentialTimeframe: {
          startDate: data.dateInterval.from,
          endDate: data.dateInterval.to,
        },
      };
    }
    case WEARABLES: {
      const allowedAreaIds = data.allowedAreaIds ? data.allowedAreaIds : data.allowedAreasOptions && _.isArray(data.allowedAreasOptions) ? _.map(data.allowedAreasOptions, area => area.value && area.value.id) : [];
      const notAllowedAreaIds = data.notAllowedAreaIds ? data.notAllowedAreaIds : data.notAllowedAreasOptions && _.isArray(data.notAllowedAreasOptions) ? _.map(data.notAllowedAreasOptions, area => area.value && area.value.id) : [];
      return {
        deviceId: data.deviceId,
        model: data.model,
        userId: data.userId,
        type: data.type || 'BLE_BRACELET',
        allowedAreaIds: allowedAreaIds,
        notAllowedAreaIds: notAllowedAreaIds,
        secondsOutsideAllowedAreasForAlarm: data.secondsOutsideAllowedAreasForAlarm * 60 || 0,
        secondsInsideNotAllowedAreasForAlarm: data.secondsInsideNotAllowedAreasForAlarm * 60 || 0,
        emergencyButtonEnabled: data.emergencyButtonEnabled || false,
      }
    }
    case WEARABLE_SETTINGS: {
      return {
        wearableEmergencyIdleTimeMs: data.wearableEmergencyIdleTime ? parseInt(data.wearableEmergencyIdleTime, 10) * 1000 : null,
        wearableDataIdleTimeMs: data.wearableDataIdleTime ? parseInt(data.wearableDataIdleTime, 10) * 1000 : null,
        wearableAccelerometerDataIdleTimeMs: data.wearableAccelerometerDataIdleTime ? parseInt(data.wearableAccelerometerDataIdleTime, 10) * 1000 : null,
        wearableDataRssiThreshold: data.wearableDataRssiThreshold ? parseInt(data.wearableDataRssiThreshold, 10) : null,
      };
    }
    case MKS_REQUEST: {
      const dataPayload = elaborateMksRequestDataOutPayload(data);
      const dataToSend = {
        requestType: data.requestType,
        notes: data.notes,
        documents: {},
        data: dataPayload,
      };
      return dataToSend;
    }
    case LOCK_V364_CONFIGURATIONS: {
      return {
        ...data,
        inhibitTime: data.inhibitTime ? parseInt(data.inhibitTime, 10) : 0,
        fourEyesPeriod: data.fourEyesPeriod ? parseInt(data.fourEyesPeriod, 10) : 0,
        alwaysOpenTimeProfileId: data.alwaysOpenTimeProfileId ? parseInt(data.alwaysOpenTimeProfileId, 10) : 0,
        keyAlwaysOpenTimeProfileId: data.keyAlwaysOpenTimeProfileId ? parseInt(data.keyAlwaysOpenTimeProfileId, 10) : 0,
        minValidationPeriod: data.minValidationPeriod ? parseInt(data.minValidationPeriod, 10) : 0,
        openingTimeProfileId: data.openingTimeProfileId ? parseInt(data.openingTimeProfileId, 10) : 0,
        openingTime: data.openingTime ? parseInt(data.openingTime, 10) : 0,
      };
    }
    case CUSTOM_TABLE_ROW_DATA: {
      const formattedData = {};
      _.forEach(data, (value, key) => {
        formattedData[key] = value;
      });
      return {
        data: {
          ...formattedData,
        },
      };
    }
    case CARD_WITH_PROFILE: {
      return {
        type: data.type,
        deviceId: data.deviceId,
        notes: data.notes,
        userId: data.userId,
        passageMode: data.passageMode,
      }
    }
    case OFFICE_MODE_PROGRAM: {
      const timeIntervalFrom = (moment(data.programStartTime).hours() * 3600) + (moment(data.programStartTime).minutes() * 60) + moment(data.programStartTime).seconds();
      const timeIntervalTo = (moment(data.programEndTime).hours() * 3600) + (moment(data.programEndTime).minutes() * 60) + moment(data.programEndTime).seconds();
      const automatic = data.programType === OFFICE_MODE_PROGRAM_TYPES.AUTOMATIC;
      const semiAutomatic = data.programType === OFFICE_MODE_PROGRAM_TYPES.SEMIAUTOMATIC;
      return {
        automatic,
        semiAutomatic,
        daysOfTheWeek: data.daysOfTheWeek,
        enableOnFirstAccess: data.enableOnFirstAccess,
        timeInterval: {
          from: timeIntervalFrom,
          to: timeIntervalTo,
        },
      };
    }
    case INVITATION: {
      const fromDate = data.validityDateFrom;
      const toDate = data.validityDateTo;
      const validityStart = moment(fromDate).hour(moment(data.validityTimeFrom).hours()).minutes(moment(data.validityTimeFrom).minutes()).valueOf();
      const validityEnd = moment(toDate).hour(moment(data.validityTimeTo).hours()).minutes(moment(data.validityTimeTo).minutes()).valueOf();
      const timeIntervalFrom = (moment(data.timeIntervalFrom).hours() * 3600) + (moment(data.timeIntervalFrom).minutes() * 60) + moment(data.timeIntervalFrom).seconds();
      const timeIntervalTo = (moment(data.timeIntervalTo).hours() * 3600) + (moment(data.timeIntervalTo).minutes() * 60) + moment(data.timeIntervalTo).seconds();
      let smartLocks = data.selectedLocks && data.selectedLocks.data ? data.selectedLocks.data : [];
      smartLocks = data.selectedLocks && _.isArray(data.selectedLocks) && !data.selectedLocks.data  ? data.selectedLocks : smartLocks;
      const smartLockIds = _.map(smartLocks, lock => lock.id);
      const emails = data.emails ? _.compact(_.map(data.emails, email => email && email.trim())) : [];
      const daysOfTheWeek = data.daysOfTheWeek;
      return {
        dateInterval: {
          from: validityStart,
          to: validityEnd,
        },
        timeInterval: {
          from: timeIntervalFrom,
          to: timeIntervalTo,
        },
        name: data.name,
        smartLockIds,
        daysOfTheWeek,
        numberOfDevices: data.numberOfDevices,
        emails
      };
    }
    case COMMUNICATION: {
      const fromDate = moment(data.startDate).hour(moment(data.startTime).hour()).minute(moment(data.startTime).minute()).valueOf();
      const toDate = Math.max(moment(data.endDate).endOf('day').valueOf(), moment(data.startDate).endOf('day').valueOf());
      const emailDate = data.emailStatus !== COMMUNICATION_EMAIL_STATUSES.DISABLED ? fromDate : undefined
      return {
        ..._.omit(data, [
          'startDate',
          'startTime',
          'endDate',
          'status',
        ]),
        fromDate,
        toDate,
        emailDate,
      };
    }
    case REGISTRY_ITEM: {
      const selectedGuest = data && data.selectedGuestTags && _.isArray(data.selectedGuestTags) && !_.isEmpty(data.selectedGuestTags) ? _.first(data.selectedGuestTags) : null;
      return {
        ..._.omit(data, ['selectedGuestTags', 'guestTags', 'recipient', 'createdBy']),
        recipientId: selectedGuest ? selectedGuest.id : null,
      };
    }
    case RESERVATION_DATES: {
      const momentTimeFrom = moment(data.startTime);
      const momentTimeTo = moment(data.endTime);
      return {
        dateFrom: moment(data.dateFrom).hour(momentTimeFrom.hour()).minute(momentTimeFrom.minute()).valueOf(),
        dateTo: moment(data.dateTo).hour(momentTimeTo.hour()).minute(momentTimeTo.minute()).valueOf(),
      };
    }

    case INVITATION_DATES: {
      return {
        validityDateFrom: moment(data.dateFrom).valueOf(),
        validityDateTo: moment(data.dateTo).valueOf(),
      };
    }
    case RESERVATION: {
      return {
        userId: data.reservationUserId,
        fromDate: data.dateFrom,
        checkInNotNecessary: data.checkInNotNecessary,
        toDate: data.dateTo,
        resource: {
          id: data.resourceId,
        },
        title: data.title,
        description: data.description,
        numberOfPeople: data.numberOfPeople,
        invitedEmails: data.invitedEmails || [],
      };
    }
    case EVENT: {
      const momentTimeFrom = moment(data.timeFrom);
      const momentTimeTo = moment(data.timeTo);
      return {
        fromDate: moment(data.dateFrom).hour(momentTimeFrom.hour()).minute(momentTimeFrom.minute()).valueOf(),
        toDate: moment(data.dateTo).hour(momentTimeTo.hour()).minute(momentTimeTo.minute()).valueOf(),
        title: data.title,
        description: data.description,
        id: data.id,
        address: data.location,
        link: data.link,
      };
    }
    case GUEST: {
      const groupedTags = _.partition(data.tags, tag => tag.timeFrom && tag.timeTo);
      let customAttributes = undefined;
      if (!data.ignoreCustomFields) {
        const stateCustomFields = data.customFields;
        customAttributes = _.reduce(data.customFields, (acc, curr) => {
          const value = formatOutputCustomFieldValue(data[curr.keyValue], curr.type);
          acc = {
            ...acc,
            [curr.keyValue]: value,
          };
          return acc;
        }, {});
      }
      let mobileUuidState = data.mobileUuidState;
      if (_.includes([MOBILE_UDID_STATES.SET, MOBILE_UDID_STATES.RESET], data.mobileUuidState)) {
        mobileUuidState = undefined;
      }

      return {
        id: data.id,
        email: data.email,
        username: data.email || data.username,
        firstname: data.firstname,
        lastname: data.lastname,
        password: data.password,
        role: data.role,
        roleIds: data.roleIds,
        companyName: data.companyName,
        mobileUuidState: mobileUuidState,
        accessProfileId: data.accessProfileId && data.accessProfileId.length ? data.accessProfileId : 0,
        userTagIds: groupedTags[1] ? _.map(groupedTags[1], val => val.id) : [],
        userTagIdsWithTime: groupedTags[0] ? _.map(groupedTags[0], (tag) => {
          const timeFrom = moment(tag.timeFrom);
          const timeTo = moment(tag.timeTo);
          const tagIntervalTo = moment(tag.dateTo).hour(timeTo.hour()).minute(timeTo.minute()).second(0);
          const tagIntervalFrom = moment(tag.dateFrom).hour(timeFrom.hour()).minute(timeFrom.minute()).second(0);

          return {
            id: tag.id,
            interval: {
              from: tagIntervalFrom.valueOf(),
              to: tagIntervalTo.valueOf(),
            },
          };
        }) : [],
        customAttributes,
        companyNotificationsEnabled: data.companyNotificationsEnabled,
        canTogglePassageMode: data.canTogglePassageMode,
        using2FA: data.using2FA,
      };
    }
    case PLATFORM_USER: {
      return {
        id: data.id,
        email: data.email,
        firstname: data.firstname,
        lastname: data.lastname,
        password: data.password,
        role: data.role,
        roleIds: data.roleIds,
        companyName: data.companyName,
        username: data.username,
        using2FA: data.using2FA,
        twoFactorType: data.twoFactorType,
        companyNotificationsEnabled: data.companyNotificationsEnabled?data.companyNotificationsEnabled:false,
      };
    }
    case GUEST_TAG:
      return {
        id: data.id,
        name: data.name,
        type: data.type ? data.type.name : undefined,
        color: data.color ? data.color.hex : undefined,
      };
    case LOCK_TAG:
      return {
        id: data.id,
        name: data.name,
        type: data.type ? data.type.name : undefined,
        color: data.color ? data.color.hex : undefined,
      };
    case LOCK: {
      const stateCustomFields = data.customFields;
      const customAttributes = _.reduce(stateCustomFields, (acc, curr) => {
        const value = formatOutputCustomFieldValue(data[curr.keyValue], curr.type);
        acc = {
          ...acc,
          [curr.keyValue]: value,
        };
        return acc;
      }, {});
      return {
        id: data.id,
        lockTagIds: _.map(data.tags, val => val.id),
        name: data.name,
        customAttributes,
      };
    }
    case TAG_DATES: {
      const timeFrom = moment(data.timeFrom);
      const timeTo = moment(data.timeTo);
      return {
        dateFrom: moment(data.dateFrom).hours(timeFrom.hours()).minutes(timeFrom.minutes()),
        dateTo: moment(data.dateTo).hours(timeTo.hours()).minutes(timeTo.minutes()),
      };
    }
    case TIME_PROFILE: {
      let lockTags = data.lockTags;
      if (!_.isArray(lockTags)) {
        lockTags = [lockTags];
      }
      const timeIntervalFrom =
        (moment(data.timeIntervalFrom).hours() * 3600) + (moment(data.timeIntervalFrom).minutes() * 60) + moment(data.timeIntervalFrom).seconds();
      const timeIntervalTo =
        (moment(data.timeIntervalTo).hours() * 3600) + (moment(data.timeIntervalTo).minutes() * 60) + moment(data.timeIntervalTo).seconds();
      
        let timeProfileData = {
        ...data,
        dateInterval: {
          from: moment(data.credentialTimeframe.startDate).startOf('day').valueOf(),
          to: moment(data.credentialTimeframe.endDate).endOf('day').valueOf(),
        },
        timeInterval: {
          from: timeIntervalFrom,
          to: timeIntervalTo,
        },
        name: data.name,
        daysOfTheWeek: data.daysOfTheWeek,
        lockTagIds: _.map(lockTags, val => val.id),
        lockTagMatchingMode: data.lockTagMatchingMode,
        openOnPrivacy: data.openOnPrivacy || false,
        alwaysOpen: data.alwaysOpen || false,
        holidays: data.holidays || false,
      };
      if (data.additionalTimeRange_additional && !_.isEmpty(data.additionalTimeRange_additional)) {
        const additionaTimeRange = _.first(data.additionalTimeRange_additional);
        const timeIntervalFrom = (moment(additionaTimeRange.timeIntervalFrom).hours() * 3600) + (moment(additionaTimeRange.timeIntervalFrom).minutes() * 60) + moment(additionaTimeRange.timeIntervalFrom).seconds();
        const timeIntervalTo = (moment(additionaTimeRange.timeIntervalTo).hours() * 3600) + (moment(additionaTimeRange.timeIntervalTo).minutes() * 60) + moment(additionaTimeRange.timeIntervalTo).seconds();
        const formattedTimeRange = {
            timeInterval: {
              from: timeIntervalFrom,
              to: timeIntervalTo,
            },
            daysOfTheWeek: additionaTimeRange.daysOfTheWeek,
        };
        timeProfileData = {
          ...timeProfileData,
          additionalTimeRange: formattedTimeRange,
        }
      }
      return timeProfileData;
    }
    case TIME_RANGE: {
      const timeIntervalFrom =
        (moment(data.timeIntervalFrom).hours() * 3600) + (moment(data.timeIntervalFrom).minutes() * 60) + moment(data.timeIntervalFrom).seconds();
      const timeIntervalTo =
        (moment(data.timeIntervalTo).hours() * 3600) + (moment(data.timeIntervalTo).minutes() * 60) + moment(data.timeIntervalTo).seconds();
        return {
          timeInterval: {
            from: timeIntervalFrom,
            to: timeIntervalTo,
          },
          daysOfTheWeek: data.daysOfTheWeek,
          holidays: data.holidays
        }
    }
    case CREDENTIAL: {
      const timeIntervalFrom =
        (moment(data.timeIntervalFrom).hours() * 3600) + (moment(data.timeIntervalFrom).minutes() * 60) + moment(data.timeIntervalFrom).seconds();
      const timeIntervalTo =
        (moment(data.timeIntervalTo).hours() * 3600) + (moment(data.timeIntervalTo).minutes() * 60) + moment(data.timeIntervalTo).seconds();
      const dateIntervalTimeFrom = moment(data.credentialTimeframe.startDate)
        .hour(moment(data.dateIntervalTimeFrom).hours())
        .minute(moment(data.dateIntervalTimeFrom).minutes()).startOf('minute').valueOf();
      const dateIntervalTimeTo = moment(data.credentialTimeframe.endDate)
        .hour(moment(data.dateIntervalTimeTo).hours())
        .minute(moment(data.dateIntervalTimeTo).minutes()).endOf('minute').valueOf();
      let guestTags = data.guestTags;
      if (!_.isArray(guestTags)) {
        guestTags = [guestTags];
      }

      let lockTags = data.lockTags;
      if (!_.isArray(lockTags)) {
        lockTags = [lockTags];
      }
      return {
        id: data.id,
        name: data.name,
        description: data.description,
        lockTagIds: _.map(lockTags, val => val.id),
        guestTagIds: _.map(guestTags, val => val.id),
        lockTagMatchingMode: data.lockTagMatchingMode,
        guestTagMatchingMode: data.guestTagMatchingMode,
        notes: data.notes,
        dateInterval: {
          from: dateIntervalTimeFrom,
          to: dateIntervalTimeTo,
        },
        timeInterval: {
          from: timeIntervalFrom,
          to: timeIntervalTo,
        },
        daysOfTheWeek: data.daysOfTheWeek,
        additionalTimeRange: data.additionalTimeRange,
        openOnPrivacy: data.openOnPrivacy || false,
        alwaysOpen: data.alwaysOpen || false,
        holidays: data.holidays || false,
      };
    }
    case LOG:
      return {
        ...data,
        freeTextSearch: data.freeTextSearch ? data.freeTextSearch : undefined,
      };
    case SETTING:
      return {
        name: data.name,
        email: data.email,
        address: data.address,
        city: data.city,
        fax: data.fax,
        logoUrl: data.logoUrl,
        phone: data.phone,
        province: data.province,
        state: data.state,
        taxCode: data.taxCode,
        vat: data.vat,
        zipCode: data.zipCode,
        themeName: data.themeName,
        logo: data.logo,
        mainFirstname: data.mainFirstname,
        mainLastname: data.mainLastname,
        mainEmail: data.mainEmail,
        mobileUuidDefaultState: data.mobileUuidDefaultState,
        guestInvitationLimitDefault: data.guestInvitationLimitDefault,
        sessionTimeoutSeconds: data.sessionTimeoutSeconds,
      };
    case APPLICATION_SETTING:
      return {
        appUrl: data.appUrl,
        privacyUrl: data.privacyUrl,
        termsUrl: data.termsUrl,
        helpCenter: data.helpCenter,
        androidApp: data.androidApp,
        iosApp: data.iosApp,
      };
    case NOTIFICATION_SETTING:
      return {
        gatewayOfflineForMinutes: data.gatewayMode===COMPANY_NOTIFICATIONS_GATEWAY_STATES.ON?data.gatewayOfflineForMinutes:0,
        smartLockBatteryLevel: data.batteryMode===COMPANY_NOTIFICATIONS_BATTERY_STATES.ON?(
          data.smartLockBatteryLevelSelected===COMPANY_NOTIFICATIONS_BATTERY_LEVELS.L25?25:
          data.smartLockBatteryLevelSelected===COMPANY_NOTIFICATIONS_BATTERY_LEVELS.L50?50:
          75
        ):0,
        atlasOffline: data.atlasMode===COMPANY_NOTIFICATIONS_ATLAS_STATES.ON?true:false,
        sameNotificationAfterHours: data.repeatMode===COMPANY_NOTIFICATIONS_REPEAT_STATES.ON?data.sameNotificationAfterHours:0,
        credentialsWillExpireInHours: data.credentialsMode===COMPANY_NOTIFICATIONS_CREDENTIALS_STATES.ON?Math.floor(data.credentialsWillExpireInHours)*24:0,
        elementsUsagePercentage: data.elementsUsageMode===COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_STATES.ON?(
          data.elementsUsageLevelSelected===COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L50?50:
          data.elementsUsageLevelSelected===COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L60?60:
          data.elementsUsageLevelSelected===COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L70?70:
          data.elementsUsageLevelSelected===COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L80?80:
          data.elementsUsageLevelSelected===COMPANY_NOTIFICATIONS_ELEMENTS_USAGE_LEVELS.L90?90:
          50
        ):0,
        emails: data.emails.filter(e => Boolean(e) && isValidEmail(e)) || [],
      };
    case RESOURCE: {
      const timeIntervalFrom =
        (moment(data.timeIntervalFrom).hours() * 3600) + (moment(data.timeIntervalFrom).minutes() * 60) + moment(data.timeIntervalFrom).seconds();
      const timeIntervalTo =
        (moment(data.timeIntervalTo).hours() * 3600) + (moment(data.timeIntervalTo).minutes() * 60) + moment(data.timeIntervalTo).seconds();

      let guestTags = data.resourceUserTags;
      if (guestTags && _.isArray(guestTags) && guestTags[0] && _.isObject(guestTags[0])) guestTags = _.map(data.resourceUserTags, val => val.id);

      let lockTags = data.resourceSmartLockTags;
      if (lockTags && _.isArray(lockTags) && lockTags[0] && _.isObject(lockTags[0])) lockTags = _.map(data.resourceSmartLockTags, val => val.id);

      const linkedResourcesIds = _.map(data.dependencies, dependency => dependency.destination.id);

      const workspace = _.isObject(data.workspace) && data.workspace.value ? data.workspace.value : (data.workspace || '');

      const additionalTimeIntervals = []
      if (data && data.additionalTimeIntervals) {
        data.additionalTimeIntervals.forEach((item) => {
          const additionalTimeIntervalFrom =
            (moment(item.timeIntervalFrom).hours() * 3600) + (moment(item.timeIntervalFrom).minutes() * 60) + moment(item.timeIntervalFrom).seconds();
          const additionalTimeIntervalTo =
            (moment(item.timeIntervalTo).hours() * 3600) + (moment(item.timeIntervalTo).minutes() * 60) + moment(item.timeIntervalTo).seconds();
          additionalTimeIntervals.push({
            from: additionalTimeIntervalFrom,
            to: additionalTimeIntervalTo,
          })
        });
      }

      const openIfReservationStartsInMinutes = data.openIfReservationStartsInMinutes && data.openIfReservationStartsInMinutes>0 ? data.openIfReservationStartsInMinutes : 0
      const smartLockIdToOpenIfReservationStartsInMinutes = openIfReservationStartsInMinutes && data.smartLockIdToOpenIfReservationStartsInMinutes > 0 ?
        data.smartLockIdToOpenIfReservationStartsInMinutes : null
      const openIfNoReservationStartsInMinutes = data.openIfNoReservationStartsInMinutes && data.openIfNoReservationStartsInMinutes>0 ? data.openIfNoReservationStartsInMinutes : 0
      const smartLockIdToOpenIfNoReservationStartsInMinutes = openIfNoReservationStartsInMinutes > 0 && data.smartLockIdToOpenIfNoReservationStartsInMinutes ?
        data.smartLockIdToOpenIfNoReservationStartsInMinutes : null

      const notificationEmails = data.notificationEmails ? data.notificationEmails.filter(e=>Boolean(e)) : []

      return {
        id: data.id,
        name: data.name,
        description: data.description && data.description.length ? data.description : ' ', // WORKAROUND FOR NULLABILITY OF DESCRIPTION
        resourceSmartLockTags: lockTags,
        resourceUserTags: guestTags,
        imageUrl: data.isCustomMedia ? '' : data.imageUrl,
        lockTagMatchingMode: data.lockTagMatchingMode,
        userTagMatchingMode: data.userTagMatchingMode,
        freeBeforeMinutes: data.freeBeforeMinutes != null ? parseFloat(data.freeBeforeMinutes) : 5,
        freeAfterMinutes: data.freeAfterMinutes != null ? parseFloat(data.freeAfterMinutes) : 5,
        checkInWindowMinutes: data.checkInWindowMinutes != null ? parseFloat(data.checkInWindowMinutes) : 15,
        checkInWindowBeforeMinutes: data.checkInWindowBeforeMinutes != null ? parseFloat(data.checkInWindowBeforeMinutes) : 15,
        locksOpenValidAfterMinutes: data.locksOpenValidAfterMinutes != null ? parseFloat(data.locksOpenValidAfterMinutes) : 5,
        maximumReservationTimeMinutes: data.maximumReservationTimeHours != null ? parseFloat(data.maximumReservationTimeHours * 60) : 60,
        minimumReservationTimeMinutes: data.minimumReservationTimeHours != null ? parseFloat(data.minimumReservationTimeHours * 60) : 60,
        deleteByUserWithPenaltyBeforeMinutes: data.deleteByUserWithPenaltyBeforeMinutes != null ? parseFloat(data.deleteByUserWithPenaltyBeforeMinutes) : 0,
        checkInSmartLockId: data.checkInSmartLockId,
        confirmationWindowMinutes: data.confirmationWindowMinutes,
        linkedResourcesIds,
        workspace,
        customMedia: data.customMedia,
        dateInterval: {
          from: moment(data.credentialTimeframe.startDate).startOf('day').valueOf(),
          to: moment(data.credentialTimeframe.endDate).endOf('day').valueOf(),
        },
        timeInterval: {
          from: timeIntervalFrom,
          to: timeIntervalTo,
        },
        additionalTimeIntervals: additionalTimeIntervals,
        daysOfTheWeek: data.daysOfTheWeek,
        type: data.type,
        email: data.email,
        automaticCheckIn: data.automaticCheckIn,
        capacity: data.capacity,
        slotMinutes: data.slotMinutes,
        maxActiveReservationsPerUser: data.maxActiveReservationsPerUser,
        reservationCutoffTimeMinutes: data.reservationCutoffTimeMinutes != null ? parseFloat(data.reservationCutoffTimeMinutes) : 0,
        openIfReservationStartsInMinutes: openIfReservationStartsInMinutes,
        smartLockIdToOpenIfReservationStartsInMinutes: smartLockIdToOpenIfReservationStartsInMinutes,
        openIfNoReservationStartsInMinutes: openIfNoReservationStartsInMinutes,
        smartLockIdToOpenIfNoReservationStartsInMinutes: smartLockIdToOpenIfNoReservationStartsInMinutes,
        notificationEmails: notificationEmails,
        checkInButtonInAppDisabled: data.checkInButtonInAppDisabled || false,
        enableInvitedEmails: data.enableInvitedEmails || false,
        timeZone: data.timeZone,
      };
    }

    case RESOURCE_FORM_INIT: {
      return {
        timeIntervalFrom: moment().startOf('day').valueOf(),
        timeIntervalTo: moment().endOf('day').valueOf(),
        credentialTimeframe: {
          startDate: moment().valueOf(),
          endDate: moment().add('years', 5).valueOf(),
        },
        checkInWindowMinutes: 15,
        deleteByUserWithPenaltyBeforeMinutes: 0,
        checkInWindowBeforeMinutes: 15,
        locksOpenValidAfterMinutes: 15,
        daysOfTheWeek: [1, 2, 3, 4, 5, 6, 7],
        maximumReservationTimeHours: 4,
        minimumReservationTimeHours: 0,
        freeAfterMinutes: 0,
        freeBeforeMinutes: 0,
        lockTagMatchingMode: MATCH_TAG_MODE.AT_LEAST_ONE_TAG,
        userTagMatchingMode: MATCH_TAG_MODE.AT_LEAST_ONE_TAG,
        automaticCheckIn: false,
        capacity: 1,
        capacityType: RESOURCE_CAPACITY_TYPE.ONE,
        slotMinutes: RESOURCE_CAPACITY_SLOTS.MINUTES_15.value,
        maxActiveReservationsPerUser: 0,
        reservationCutoffTimeMinutes: 0,
        maximumReservationSlotsNumber: 1,
        openIfReservationStartsInMinutes: 0,
        smartLockIdToOpenIfReservationStartsInMinutes: null,
        openIfNoReservationStartsInMinutes: 0,
        smartLockIdToOpenIfNoReservationStartsInMinutes: null,
        notificationEmails: [],
        checkInButtonInAppDisabled: false,
        enableInvitedEmails:false,
        timeZone: null,
      };
    }
    case RESOURCE_FORM_EDIT_INIT: {
      const timeIntervalFrom = moment().startOf('day').add(data.timeInterval.from, 'seconds').valueOf();
      const timeIntervalTo = moment().startOf('day').add(data.timeInterval.to, 'seconds').valueOf();
      const linkedResourcesIds = _.map(data.dependencies, dependency => dependency.destination.id);
      const resourceAccessoryIds = _.map(data.resourceAccessories, accessory => accessory.id);
      const isCustomMedia = data.customMedia;
      const additionalTimeIntervals = []
      if (data && data.additionalTimeIntervals) {
        data.additionalTimeIntervals.forEach((item) => {
          const additionalTimeIntervalFrom = moment().startOf('day').add(item.from, 'seconds').valueOf();
          const additionalTimeIntervalTo = moment().startOf('day').add(item.to, 'seconds').valueOf();
          additionalTimeIntervals.push({
            timeIntervalFrom: additionalTimeIntervalFrom,
            timeIntervalTo: additionalTimeIntervalTo,
          })
        });
      }
      return {
        ...data,
        additionalTimeIntervals: additionalTimeIntervals,
        timeIntervalFrom,
        timeIntervalTo,
        linkedResourcesIds,
        resourceAccessoryIds,
        isCustomMedia,
        imageUrl: data.media ? data.media: data.imageUrl,
        maximumReservationTimeHours: data.maximumReservationTimeMinutes / 60,
        minimumReservationTimeHours: data.minimumReservationTimeMinutes / 60,
        lockTagMatchingMode: MATCH_TAG_MODE.AT_LEAST_ONE_TAG,
        automaticCheckIn: data.automaticCheckIn,
        credentialTimeframe: {
          startDate: data.dateInterval.from,
          endDate: data.dateInterval.to,
        },
        capacityType: data.capacity && data.capacity > 1 ? RESOURCE_CAPACITY_TYPE.MULTI : RESOURCE_CAPACITY_TYPE.ONE,
        slotMinutes: Object.keys(RESOURCE_CAPACITY_SLOTS).filter(e=>RESOURCE_CAPACITY_SLOTS[e].value==data.slotMinutes).length?
          RESOURCE_CAPACITY_SLOTS[Object.keys(RESOURCE_CAPACITY_SLOTS).filter(e=>RESOURCE_CAPACITY_SLOTS[e].value==data.slotMinutes)].value : 
          RESOURCE_CAPACITY_SLOTS.MINUTES_15.value,
        maximumReservationSlotsNumber: (data.minimumReservationTimeMinutes && data.maximumReservationTimeMinutes) ? 
          Math.floor(data.maximumReservationTimeMinutes/data.minimumReservationTimeMinutes) : 1,
        checkInButtonInAppDisabled: data.checkInButtonInAppDisabled || false,
      };
    }
    case ACCESS_PROFILE: {
      const timeIntervalFrom =
        (moment(data.timeIntervalFrom).hours() * 3600) + (moment(data.timeIntervalFrom).minutes() * 60) + moment(data.timeIntervalFrom).seconds();
      const timeIntervalTo =
        (moment(data.timeIntervalTo).hours() * 3600) + (moment(data.timeIntervalTo).minutes() * 60) + moment(data.timeIntervalTo).seconds();
      const dateIntervalTimeFrom = moment(data.credentialTimeframe.startDate)
        .hour(moment(data.dateIntervalTimeFrom).hours())
        .minute(moment(data.dateIntervalTimeFrom).minutes()).startOf('minute').valueOf();
      const dateIntervalTimeTo = moment(data.credentialTimeframe.endDate)
        .hour(moment(data.dateIntervalTimeTo).hours())
        .minute(moment(data.dateIntervalTimeTo).minutes()).startOf('minute').valueOf();
      let lockTags = data.lockTags;
      if (!_.isArray(lockTags)) {
        lockTags = [lockTags];
      }
      return {
        id: data.id,
        name: data.name,
        lockTagIds: _.map(lockTags, val => val.id),
        lockTagMatchingMode: data.lockTagMatchingMode,
        dateInterval: {
          from: dateIntervalTimeFrom,
          to: dateIntervalTimeTo,
        },
        timeInterval: {
          from: timeIntervalFrom,
          to: timeIntervalTo,
        },
        daysOfTheWeek: data.daysOfTheWeek,
        additionalTimeRange: data.additionalTimeRange,
      };
    }
    
    case TICKET: {
      return {
        ...data,
      };
    }
    
    case TICKET_CATEGORY: {
      return {
        ...data,
      };
    }
    
    case AREA: {
      return {
        ...data,
        gatewayIds: data.gateways ? _.map(data.gateways, gateway => gateway.value) : [],
        requiredSecondsForWearableInArea: data.requiredSecondsForWearableInArea ? data.requiredSecondsForWearableInArea * 60 : 60,
      };
    }
    
    case AREA_OCCUPANCY: {
      return {
        ...data,
      };
    }
    
    case AREA_OCCUPANCY_HOUR: {
      return {
        ...data,
      };
    }
    
    case PRIVATE_UNIT: {
      return {
        ...data,
      };
    }
    
    case PRIVATE_UNIT_TEMPLATE: {
      return {
        ...data,
      };
    }

    case AREA_RULE: {
      return {
        ...data,
      };
    }
    
    case LOCKER: {
      return {
        ...data,
      };
    }
    
    case LOCKER_RESERVATION: {
      return {
        ...data,
      };
    }
    
    case INTERCOM: {
      return {
        ...data,
      };
    }
    
    case INTERCOM_EXTENSION: {

      return {
        ...data,
      };
    }
    
    case INTERCOM_EXTENSION_GROUP: {
      return {
        ...data,
      };
    }
    
    case INTERCOM_HYPER_TILE: {
      return {
        ...data,
      };
    }
    
    case COMMUNICATION_USER: {
      return {
        ...data,
      };
    }

    case WEARABLES: {
      return {
        ...data,
        batteryLevel: calculateWearableBatteryLevel(data.battery),
      };
    }

    default: return {};
  }
}

export function resourceDataFormatter(DTO) {
  const base = [
    { label: 'Mo', value: false },
    { label: 'Tu', value: false },
    { label: 'We', value: false },
    { label: 'Th', value: false },
    { label: 'Fr', value: false },
    { label: 'Sa', value: false },
    { label: 'Su', value: false },
  ];
  const checkFields = ['maxReservationLength', 'checkInLimit', 'lockDownPeriod'];
  let daysOfTheWeek;
  if (_.size(DTO.daysOfTheWeek) > 0) {
    daysOfTheWeek = _.map(base, (option, index) => {
      if (_.includes(DTO.daysOfTheWeek, index)) {
        return { label: option.label, value: true };
      } else {
        return { label: option.label, value: false };
      }
    });
  } else {
    daysOfTheWeek = base;
  }
  const data = _.set(DTO, 'daysOfTheWeek', daysOfTheWeek);
  _.map(checkFields, el => {
    if (!_.isArray(data[el])) _.set(data, el, []);
  });
  return data;
}
